import { CartTicket } from "../../../../../types/CartType"
import { cartGuestNamePrularizer } from "../../../../../utils/namePluralizer"
import { formatPrice } from "../../../../../utils/pricingUtils"
import styles from '../CartRoomItem/CartRoomItem.module.scss';
import { differenceInDays, format, parseISO, toDate } from "date-fns";

type CartRoomItem = {
  rooms: CartTicket[],
  icon: JSX.Element,
  remove: (ticketIds: string[], dateStr?: string | undefined) => void
}


export function CartRoomItem({ rooms, icon, remove }: CartRoomItem) {

  const hotelTitle = rooms[0].data.attraction_title
  const key = rooms.map(t => t.cart_item_id).join("-")
  const dateTo = toDate(parseISO(rooms[0].attributes[42].toString()));
  const dateFrom = toDate(parseISO(rooms[0].attributes[5].toString()));
  const dateDifference = (dateFrom: Date, dateTo: Date) => {
    return differenceInDays(dateTo, dateFrom) === 1 ? `${differenceInDays(dateTo, dateFrom)} Night` : `${differenceInDays(dateTo, dateFrom)} Nights`
  }
  const dateInfo = <div className={styles.dateInfo}>{format(parseISO(rooms[0].attributes[5].toString()), 'MMMM d, yyyy')} - {format(parseISO(rooms[0].attributes[42].toString()), 'MMMM d, yyyy')} ({dateDifference(dateFrom, dateTo)})</div>


  return (
    <div key={key} className={styles.cartListItem}>
      <div className={styles.icon}>
        {icon}
      </div>
      <div className={styles.info}>
        <h2>{hotelTitle}</h2>
        {dateInfo}
        {rooms.map((ticket, i) => {
          return (
            <div className={styles.room} key={ticket.cart_item_id}>
              <div>
                <b>Room {i + 1}</b> 
                <div>{cartGuestNamePrularizer(+rooms[i].attributes[48], +rooms[i].attributes[49], +rooms[i].attributes[87])}</div>
                <div className={styles.ticketInfo}>{rooms[i].title}</div>
              </div>
              <div>
                <div className={styles.qty}>
                  <p className={styles.price}>{`£${formatPrice(ticket.price)}`}</p>
                </div>
              </div>
            </div>
          )
        })}
        
        <a className={styles.remove} onClick={() => remove(rooms.map(t => t.ticket_id))}>Remove</a>
      </div>
    </div>
  )
}


